import React from "react";
import { useHistory } from "react-router-dom";
import { trackEvent } from "../utils/analytics";
import "./ProHunterTrialBanner.scss";

const ProHunterTrialBanner = ({ page = "home" }) => {
  const history = useHistory();

  const handleActivate = () => {
    trackEvent("trial_banner_click", "payment", { page });
    history.push("/pro-hunter-trial");
  };

  return (
    <div className="ph-home-banner">
      <div className="ph-home-banner-text">
        <strong>30 days of ProHunter, free</strong>
        <span>
          Unlimited scans, ATS insights, AI rewrites, and recruiter view.
          You will not be charged during the trial.
        </span>
      </div>
      <button type="button" className="ph-home-banner-cta" onClick={handleActivate}>
        Activate free trial
      </button>
    </div>
  );
};

export default ProHunterTrialBanner;
